import { fromJS } from 'immutable'
import {
  MASTER_DATA_GET_REQUEST,
  MASTER_DATA_GET_SUCCESS,
  MASTER_DATA_GET_FAILURE,
} from '../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case MASTER_DATA_GET_REQUEST:
      return state
        .set('isFetching', true)
    case MASTER_DATA_GET_SUCCESS:
      return state
        .set('masterData', fromJS(action.payload.masterDatas))
        .set('isFetching', false)
    case MASTER_DATA_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/master-data/master-data-get-reducer.js